import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";

const defaultIndicators = {
    gridPulsedVoltageSetPoint: "---",
    heaterVoltageSetPoint: "---",
    arcProgramSetPoint: "---",
    arcCounter: "---",
    injectorVoltage: "---",
    injectorCurrent: "---",
    powerSupplyCurrent: "---",
    powerSupplyVoltage: "---",
    gridVoltage: "---",
    heaterVoltage: "---",
    heaterCurrent: "---",
    gridPulseVoltage: "---",
    vTrimVoltage: "---",
    status: {
        acPowerSupply: false,
        triggerPresent: false,
        arcFault: false,
        interlockIn: false,
        interlockOut: false,
        cathodeCurrentFault: false,
        overTemp: false,
        spareTwo: false,
    }
};

export default function SpellmanIcaReadBack({pipe, data}) {
    const indicators = data
        ? Object.assign(defaultIndicators, {
            gridPulsedVoltageSetPoint: data["grid_pulsed_voltage_set_point"] || defaultIndicators.gridPulsedVoltageSetPoint,
            heaterVoltageSetPoint: data["heater_voltage_set_point"] || defaultIndicators.heaterVoltageSetPoint,
            arcProgramSetPoint: data["arc_program_set_point"] || defaultIndicators.arcProgramSetPoint,
            arcCounter: data["arc_counter"] || defaultIndicators.arcCounter,
            injectorVoltage: data["injector_voltage"] || defaultIndicators.injectorVoltage,
            injectorCurrent: data["injector_current"] || defaultIndicators.injectorCurrent,
            powerSupplyCurrent: data["power_supply_current"] || defaultIndicators.powerSupplyCurrent,
            powerSupplyVoltage: data["power_supply_voltage"] || defaultIndicators.powerSupplyVoltage,
            gridVoltage: data["grid_voltage"] || defaultIndicators.gridVoltage,
            heaterVoltage: data["heater_voltage"] || defaultIndicators.heaterVoltage,
            heaterCurrent: data["heater_current"] || defaultIndicators.heaterCurrent,
            gridPulseVoltage: data["grid_pulse_voltage"] || defaultIndicators.gridPulseVoltage,
            vTrimVoltage: data["v_trim_voltage"] || defaultIndicators.vTrimVoltage,
            status: data["status"] ? {
                acPowerSupply: data["status"]["ac_power_supply"] || defaultIndicators.status.acPowerSupply,
                triggerPresent: data["status"]["trigger_present"] || defaultIndicators.status.triggerPresent,
                arcFault: data["status"]["arc_fault"] || defaultIndicators.status.arcFault,
                interlockIn: data["status"]["interlock_in"] || defaultIndicators.status.interlockIn,
                interlockOut: data["status"]["interlock_out"] || defaultIndicators.status.interlockOut,
                cathodeCurrentFault: data["status"]["cathode_current_fault"] || defaultIndicators.status.cathodeCurrentFault,
                overTemp: data["status"]["over_temp"] || defaultIndicators.status.overTemp,
                spareTwo: data["status"]["spare_two"] || defaultIndicators.status.spareTwo
            } : undefined
        }) : defaultIndicators;

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"column"} alignItems={"center"} spacing={2}>
                    <Grid item xs={12} container direction={"row"} justify={"center"} spacing={2}>
                        <Grid item>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="ac_power_supply"
                                        control={
                                            <Switch readOnly={true} checked={indicators.status.acPowerSupply}/>
                                        }
                                        label={
                                            <Typography style={{fontSize: "0.9rem"}}>
                                                Ac Power Supply
                                            </Typography>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="trigger_present"
                                        control={
                                            <Switch readOnly={true} checked={indicators.status.triggerPresent}/>
                                        }
                                        label={
                                            <Typography style={{fontSize: "0.9rem"}}>
                                                Trigger Present
                                            </Typography>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="arc_fault"
                                        control={
                                            <Switch readOnly={true} checked={indicators.status.arcFault}/>
                                        }
                                        label={
                                            <Typography style={{fontSize: "0.9rem"}}>
                                                Arc Fault
                                            </Typography>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="interlock_in"
                                        control={
                                            <Switch readOnly={true} checked={indicators.status.interlockIn}/>
                                        }
                                        label={
                                            <Typography style={{fontSize: "0.9rem"}}>
                                                Interlock In
                                            </Typography>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="interlock_out"
                                        control={
                                            <Switch readOnly={true} checked={indicators.status.interlockOut}/>
                                        }
                                        label={
                                            <Typography style={{fontSize: "0.9rem"}}>
                                                Interlock Out
                                            </Typography>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="cathode_current_fault"
                                        control={
                                            <Switch readOnly={true} checked={indicators.status.cathodeCurrentFault}/>
                                        }
                                        label={
                                            <Typography style={{fontSize: "0.9rem"}}>
                                                Cathode Current Fault
                                            </Typography>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="over_temp"
                                        control={
                                            <Switch readOnly={true} checked={indicators.status.overTemp}/>
                                        }
                                        label={
                                            <Typography style={{fontSize: "0.9rem"}}>
                                                Over Temp
                                            </Typography>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl>
                                <FormGroup row>
                                    <FormControlLabel
                                        value="spare_two"
                                        control={
                                            <Switch readOnly={true} checked={indicators.status.spareTwo}/>
                                        }
                                        label={
                                            <Typography style={{fontSize: "0.9rem"}}>
                                                Spare Two
                                            </Typography>
                                        }
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction={"row"} justify={"center"} spacing={2}>
                        <Grid item>
                            <TextField
                                id="grid-pulsed-voltage-set-point"
                                label="Grid Pulsed Voltage Set Point"
                                value={indicators.gridPulsedVoltageSetPoint}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="heater-voltage-set-point"
                                label="Heater Voltage Set Point"
                                value={indicators.heaterVoltageSetPoint}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="arc-program-set-point"
                                label="Arc Program Set Point"
                                value={indicators.arcProgramSetPoint}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="arc-counter"
                                label="Arc Counter"
                                value={indicators.arcCounter}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="injector-voltage"
                                label="Injector Voltage"
                                value={indicators.injectorVoltage}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="injector-current"
                                label="Injector Current"
                                value={indicators.injectorCurrent}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="power-supply-current"

                                label="Power Supply Current"
                                value={indicators.powerSupplyCurrent}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="power-supply-voltage"
                                label="Power Supply Voltage"
                                value={indicators.powerSupplyVoltage}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="grid-voltage"
                                label="Grid Voltage"
                                value={indicators.gridVoltage}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="heater-voltage"
                                label="Heater Voltage"
                                value={indicators.heaterVoltage}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="heater-current"
                                label="Heater Current"
                                value={indicators.heaterCurrent}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="grid-pulse-voltage"
                                label="Grid Pulse Voltage"
                                value={indicators.gridPulseVoltage}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="v-trim-voltage"
                                label="V Trim Voltage"
                                value={indicators.vTrimVoltage}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            }
        />
    );
}